import { render } from "./predictive-search-loading.vue?vue&type=template&id=3b67b8d3"
import script from "./predictive-search-loading.vue?vue&type=script&lang=js"
export * from "./predictive-search-loading.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__